import React from 'react';
import { Receipt } from '@mui/icons-material';
import ReportLayout from '../Components/Reports/ReportLayout';

interface TypeReportProps {
  Entete: string;
  Type: string;
}

const FRTransactionByRef: React.FC<TypeReportProps> = ({ Entete, Type }) => {
  return (
    <ReportLayout
      title={Entete}
      subtitle="Transactions par référence"
      icon={<Receipt />}
      endpoint="transaction-byref"
      extraParams={{ Type }}
      showClientRange={false}
      showDateRange={false}
      showAgence={false}
      loadAgenceData={true}
      extraFields={[
        { key: 'NumRefD', label: 'Reference début', type: 'text' },
        { key: 'NumRefF', label: 'Reference fin', type: 'text' },
      ]}
      fileNamePrefix="rapport_transaction_byref"
    />
  );
};

export default FRTransactionByRef;
